const isChristmas = true
const TopGlow = () => (
  <div
    className="spin-slow"
    css={{
      zIndex: -1,
      position: "fixed",
      left: "15%",
      /* keep translate here so rotation happens around the element center */
      transform: "translate(-50%, 0px)",
      transformOrigin: "55% 50%",
      top: -135,
      background:
        "conic-gradient(from 242deg at 50% 50%, #60B9F8 24.239592254161835deg, #4907A5 270.7325005531311deg, #00E5D5 360deg)",

      ...(isChristmas && {
        background:
          "conic-gradient(from 242deg at 50% 50%, #60E4F8 24.239592254161835deg, #8D07A5 270.7325005531311deg, #4CE500 360deg)",
      }),
      //

      filter: "blur(74px)",
      width: 320,
      height: 270,
    }}
  ></div>
)

export default TopGlow
